import { paperTrailConfig } from "@config/paperTrailConfig";
import { PapertrailClient } from "./PapertrailClient";

export const paperTrailClientInstance = new PapertrailClient(paperTrailConfig);
